import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";
  import { useToast, POSITION } from "vue-toastification";
  import store from "@/store";
  import { BuilderInterface } from "@/types/BuilderInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderLogo',
  props: {
    builderId: {},
    builderData: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const toast = useToast();
  const builder = ref<BuilderInterface>();

  const getBuilderById = () => {
    if (props.builderId) {
      store
        .dispatch("builder/getBuilderById", props.builderId)
        .then((res) => {
          builder.value = res.data;
        })
        .catch((err) => {
          console.error("Error fetching builder by id in BuilderLogo.vue", err);
          toast.error("Error fetching builder by id", {
            position: POSITION.TOP_LEFT,
          });
        });
    }
  };

  const setBuilderIfProp = (elseCallback?: () => void) => {
    if (props.builderData) {
      builder.value = props.builderData;
    } else if (elseCallback) {
      elseCallback();
    }
  };

  onMounted(() => {
    setBuilderIfProp(getBuilderById);
  });

  const fetchBuilderIfDifferent = (
    newBuilderId?: string,
    oldBuilderId?: string
  ) => {
    if (newBuilderId !== oldBuilderId) {
      getBuilderById();
    }
  };

  watch(
    () => props.builderId,
    (newBuilderId, oldBuilderId) => {
      const fetchBuilder = () =>
        fetchBuilderIfDifferent(newBuilderId, oldBuilderId);

      setBuilderIfProp(fetchBuilder);
    }
  );

  watch(
    () => props.builderData,
    () => {
      setBuilderIfProp();
    }
  );

const __returned__ = { props, toast, builder, getBuilderById, setBuilderIfProp, fetchBuilderIfDifferent, onMounted, ref, watch, get useToast() { return useToast }, get POSITION() { return POSITION }, get store() { return store }, get BuilderInterface() { return BuilderInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})